import { FormConfig, FormOverrides } from '@wix/form-viewer';

export type WixForm = NonNullable<FormConfig['formsById']>[string];

export const BOOKINGS_LOGIN_BAR_FIELD_TYPE = 'BOOKINGS_LOGIN_BAR';

// The template login bar has no target, so it is matched by id from the form schema.
export const getHiddenLoginBarOverrides = (form?: WixForm): FormOverrides =>
  Object.fromEntries(
    (form?.fields ?? [])
      .filter(
        (field) =>
          field.view?.fieldType === BOOKINGS_LOGIN_BAR_FIELD_TYPE &&
          (field.target || field.id),
      )
      .map((field) => [field.target || field.id, { hidden: true }]),
  );
